export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1572896578019-434e3e90c571?crop=entropy&cs=srgb&fm=jpg&q=90&w=1920",
  glass1: "https://images.unsplash.com/photo-1651424594549-11ceb2a57944?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  facade: "https://images.unsplash.com/photo-1653751579119-add181ae55ad?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  skylight: "https://images.unsplash.com/photo-1579583920195-bcd3036ad492?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  slidingLiving: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  sunlit: "https://images.unsplash.com/photo-1783125126583-9aba58ccb0ef?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  villa: "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  skylightBright: "https://images.unsplash.com/photo-1753902270612-f05f4741db47?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  cornerWindow: "https://images.unsplash.com/photo-1723639904174-f31d7aec160e?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  largeWindow: "https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
};

export const COMPANY = {
  name: "SOHOM uPVC Doors & Windows",
  tagline: "Precision-fabricated windows & doors",
  phone: "+91 8886600604",
  email: "sales@sohom.in",
  address: "12-5-110, Moosapet, Hyderabad 500018",
  hours: "Mon – Sat, 9:30 AM – 6:30 PM",
};

export const PRODUCTS = [
  {
    id: "casement",
    name: "Casement Doors & Windows",
    categories: ["windows", "doors"],
    badge: "Windows + Doors",
    tagline: "The classic, re-engineered for silence.",
    description:
      "Side-hung sashes on multi-point espagnolette locking. Opens a full 90° for maximum ventilation and seals airtight on TPE gaskets — as windows or full-height doors.",
    image: "/images/casement.jpg",
    specs: { uValue: "Uf 1.3 W/m²K", sound: "Up to 43 dB", glass: "5–44 mm glazing", profile: "60/70 mm · 4–5 chambers" },
  },
  {
    id: "tilt-turn",
    name: "Tilt & Turn Systems",
    categories: ["windows", "doors"],
    badge: "Windows + Doors",
    tagline: "European engineering, tropical-ready.",
    description:
      "Dual-action hardware tilts inward for secure night ventilation or swings open fully for cleaning. The connoisseur's system.",
    image: "/images/tilt-turn.jpg",
    specs: { uValue: "Uf 1.3 W/m²K", sound: "Up to 43 dB", glass: "5–44 mm glazing", profile: "60/70 mm · 4–5 chambers" },
  },
  {
    id: "sliding",
    name: "Sliding Doors & Windows",
    categories: ["windows", "doors"],
    badge: "Windows + Doors",
    tagline: "Wide spans, effortless glide.",
    description:
      "Two, three and four-track sliders on heavy-duty ball-bearing rollers with interlocking meeting rails — openings up to 6 m wide.",
    image: "/images/sliding.jpg",
    specs: { uValue: "U 2.0 W/m²K", sound: "Up to 34 dB", glass: "5–30 mm glazing", profile: "2/3/4-track · 3 chambers" },
  },
  {
    id: "slide-fold",
    name: "Slide & Fold Systems",
    categories: ["doors"],
    badge: "Door System",
    tagline: "Fold the wall away.",
    description:
      "Bi-fold panels stack neatly to one or both sides, opening entire walls to gardens and verandas — spans up to 6 m, sash heights up to 2.4 m.",
    image: "/images/slide-fold.jpg",
    specs: { uValue: "Uf 1.3 W/m²K", sound: "Up to 32 dB", glass: "5–44 mm glazing", profile: "70 mm · 5 chambers" },
  },
  {
    id: "lift-slide",
    name: "Lift & Slide Systems",
    categories: ["doors"],
    badge: "Door System",
    tagline: "Walls that disappear.",
    description:
      "Large panels lift off their seals and glide with two fingers — floor-to-ceiling glass with monsoon-proof tracks and premium comfort.",
    image: "/images/lift-slide-2.webp",
    specs: { uValue: "Uf 1.2 W/m²K", sound: "Up to 43 dB", glass: "6–44 mm glazing", profile: "176/76 mm · 5 chambers" },
  },
];

export const COLORS = [
  { name: "White", image: "/images/colors/white.jpg" },
  { name: "Anthracite Grey", image: "/images/colors/anthracite-grey.jpg" },
  { name: "Golden Oak", image: "/images/colors/golden-oak.jpg" },
  { name: "Nut Tree", image: "/images/colors/nut-tree.jpg" },
  { name: "Grey Aluminium", image: "/images/colors/grey-aluminium.jpg" },
  { name: "Ash Black", image: "/images/colors/ash-black.jpg" },
];
export const GLASS = ["Double Glazed (DGU)", "Triple Glazed (TGU)", "Laminated", "Toughened", "Performance Glasses"];

export const GALLERY = [
  { id: 1, image: "/images/projects/boulder-hills.jpg", title: "Individual Bungalow", category: "residential", location: "Boulder Hills, Gachibowli, Hyderabad", systems: "Wood-finish casement & sliding windows" },
  { id: 2, image: "/images/projects/apollo-urlife.jpg", title: "Apollo URLife Café", category: "commercial", location: "Apollo Health City, Jubilee Hills, Hyderabad", systems: "Full-height corridor glazing" },
  { id: 3, image: "/images/projects/shamshabad-villa.jpg", title: "Individual Villa", category: "residential", location: "Shamshabad, Hyderabad", systems: "Georgian-bar casement windows" },
  { id: 4, image: "/images/projects/kapra-villa.jpg", title: "Individual Villa", category: "residential", location: "Kapra, Secunderabad", systems: "Fixed picture windows & sliders" },
  { id: 5, image: "/images/projects/pragati-resorts.jpg", title: "Pragati Resorts", category: "commercial", location: "Hyderabad", systems: "Four-panel sliding doors, DGU" },
  { id: 6, image: "/images/projects/white-hill-farms.jpg", title: "White Hill Farms", category: "commercial", location: "Hyderabad", systems: "Sliding windows & fixed glazing" },
  { id: 7, image: "/images/projects/relcon-marvel.jpg", title: "Relcon Marvel Villas", category: "residential", location: "Bowenpally, Hyderabad", systems: "Casement & sliding windows, community-wide" },
  { id: 8, image: "/images/projects/souhiti-infra.jpg", title: "Souhiti Infra Projects", category: "residential", location: "Gachibowli, Hyderabad", systems: "Sliding windows across all floors" },
  { id: 9, image: "/images/projects/denkanikottai-farmhouse.jpg", title: "Farmhouse Villa", category: "residential", location: "Denkanikottai, Tamil Nadu", systems: "Wood-finish sliding doors & windows" },
  { id: 10, image: "/images/projects/film-nagar-villa.jpg", title: "Individual Villa", category: "residential", location: "Film Nagar, Hyderabad", systems: "Sliding doors & full-height glazing" },
  { id: 11, image: "/images/projects/jubilee-hills-villa.jpg", title: "Individual Villa", category: "residential", location: "Jubilee Hills, Hyderabad", systems: "Full-height window wall, casement + fixed" },
  { id: 12, image: "/images/projects/incor-carmel-heights.jpg", title: "Incor Carmel Heights", category: "residential", location: "Whitefield, Bengaluru", systems: "Windows across twin high-rise towers" },
  { id: 13, image: "/images/projects/ramky-lumina.jpg", title: "Ramky Lumina", category: "residential", location: "Electronic City, Bengaluru", systems: "Windows & balcony sliders, multi-tower" },
  { id: 14, image: "/images/projects/nandi-hills-farmhouse.jpg", title: "Farmhouse Villa", category: "residential", location: "Nandi Hills, Bengaluru", systems: "Sliders & full-height glazing" },
  { id: 15, image: "/images/projects/nandi-hills-doors.jpg", title: "Farmhouse Villa — Verandah", category: "residential", location: "Nandi Hills, Bengaluru", systems: "Four-panel sliding doors" },
  { id: 16, image: "/images/projects/benaulim-beachfront.jpg", title: "Beachfront Villa", category: "residential", location: "Benaulim, Goa", systems: "Sliding doors & pool-deck glazing" },
  { id: 17, image: "/images/projects/villa-segara.jpg", title: "Villa Segara", category: "residential", location: "Varca, Goa", systems: "Full-width sliders & picture windows" },
  { id: 18, image: "/images/projects/royal-goan-resort.jpg", title: "Royal Goan Beach Resort", category: "commercial", location: "Benaulim, Goa", systems: "Windows & doors across resort villas" },
  { id: 19, image: "/images/projects/gamaya-farms.jpg", title: "Gamaya Farms", category: "residential", location: "Vikarabad, Telangana", systems: "Tilt & turn windows with mesh" },
  { id: 20, image: "/images/projects/omni-hospitals.jpg", title: "Omni Hospitals", category: "commercial", location: "Kukatpally, Hyderabad", systems: "Windows across hospital floors" },
];
